var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('ion-item',{staticClass:"ion-text-wrap fixture-list-item",attrs:{"button":""},on:{"click":_vm.clicked}},[_c('span',[_vm._v(_vm._s(_vm.item.type_name)),_c('span',[_vm._v("- Fixture")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }